<template>
  <div class="spinner" v-show="show">
    <div class="spinner-container container1">
      <div class="circle1"></div>
      <div class="circle2"></div>
      <div class="circle3"></div>
      <div class="circle4"></div>
    </div>
    <div class="spinner-container container2">
      <div class="circle1"></div>
      <div class="circle2"></div>
      <div class="circle3"></div>
      <div class="circle4"></div>
    </div>
    <div class="spinner-container container3">
      <div class="circle1"></div>
      <div class="circle2"></div>
      <div class="circle3"></div>
      <div class="circle4"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .spinner
    position fixed
    width 70px
    height 70px
    left 50%
    top 50%
    z-index 50
    background-color rgba(0,0,0,.65)
    border-radius 5px
    transform translate3d(-50%, -50%, 0)
    -webkit-transform translate3d(-50%, -50%, 0)
  .container1 > div, .container2 > div, .container3 > div
    position absolute
    width 8px
    height 8px
    background-color rgba(#fff, 75%)
    border-radius 50%

    animation-fill-mode both
    animation bouncedelay 1.2s infinite ease-in-out
  .spinner .spinner-container
    position absolute
    width 100%
    height 100%
  .container2
    transform rotateZ(45deg)
    -webkit-transform rotateZ(45deg)
  .container3
    transform rotateZ(90deg)
    -webkit-transform rotateZ(90deg)
  .circle1
    top 20px
    left 20px
  .circle2
    top 20px
    right 20px
  .circle3
    right 20px
    bottom 20px
  .circle4
    left 20px
    bottom 20px
  .container1 .circle2
    animation-delay -0.9s
  .container1 .circle3
    animation-delay -0.6s
  .container1 .circle4
    animation-delay -0.3s
  .container2 .circle1
    animation-delay -1.1s
  .container2 .circle2
    animation-delay -0.8s
  .container2 .circle3
    animation-delay -0.5s
  .container2 .circle4
    animation-delay -0.2s
  .container3 .circle1
    animation-delay -1.0s
  .container3 .circle2
    animation-delay -0.7s
  .container3 .circle3
    animation-delay -0.4s
  .container3 .circle4
    animation-delay -0.1s

  @keyframes bouncedelay
    0%, 80%, 100%
      transform scale(0.0)
      -webkit-transform scale(0.0)
    40%
      transform scale(1.0)
      -webkit-transform scale(1.0)
</style>



// WEBPACK FOOTER //
// spinner.vue?24c001da